
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#000","version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 472.615 472.615","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('polygon',{attrs:{"points":"472.615,403.692 472.615,344.583 0,344.583 0,403.692 147.692,403.692 147.692,452.923 108.308,452.923 108.308,472.615 364.308,472.615 364.308,452.923 324.923,452.923 324.923,403.692"}}),_c('polygon',{attrs:{"points":"157.091,164.574 143.068,212.304 135.418,188.025 116.64,188.025 108.995,212.304 94.966,164.574 76.072,170.131 99.221,248.9 118.057,249.083 126.029,223.766 134.005,249.083 152.841,248.9 175.985,170.131"}}),_c('rect',{attrs:{"x":"374.154","y":"68.894","width":"19.692","height":"19.692"}}),_c('polygon',{attrs:{"points":"267.37,164.574 253.342,212.304 245.697,188.025 226.918,188.025 219.274,212.304 205.245,164.574 186.351,170.131 209.5,248.9 228.336,249.083 236.308,223.766 244.279,249.083 263.116,248.9 286.264,170.131"}}),_c('polygon',{attrs:{"points":"377.649,164.574 363.62,212.304 355.976,188.025 337.197,188.025 329.548,212.304 315.524,164.574 296.63,170.131 319.775,248.9 338.61,249.083 346.587,223.766 354.558,249.083 373.395,248.9 396.543,170.131"}}),_c('rect',{attrs:{"x":"334.769","y":"68.894","width":"19.692","height":"19.692"}}),_c('rect',{attrs:{"x":"98.462","y":"68.894","width":"187.077","height":"19.692"}}),_c('path',{attrs:{"d":"M0 0v324.891h472.615V0H0zm413.538 275.66H59.077V127.968h354.462V275.66zm0-167.385H59.077V49.198h354.462v59.077z"}})])
          )
        }
      }
    